import { Typography } from '@mui/material';
import React from 'react';
import { FlexCol, FlexRow } from '../../../common/components/v2';
import styles from '../styles.module.scss';
import { QaSection as QaSectionType } from '../types';
import QaTable from './QaTable';

const QaSection = ({
  section,
  query,
}: {
  section: QaSectionType;
  query: string;
}) => (
  <FlexRow>
    <FlexCol className={styles.Section} xs={12}>
      <FlexRow>
        <FlexCol xs={12}>
          <Typography variant="h3" color="textPrimary">
            Section: {section.title}
          </Typography>
        </FlexCol>
      </FlexRow>
      <FlexRow>
        <FlexCol xs={12}>
          <QaTable query={query} data={section.data} />
        </FlexCol>
      </FlexRow>
    </FlexCol>
  </FlexRow>
);

export default QaSection;
